// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobPreviewId-base__flZo1{color:var(--gray-11);font:var(--font-caption-medium-400);font-feature-settings:var(--feature-settings-caption-medium-400);letter-spacing:var(--letter-spacing-caption-medium-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "JobPreviewId-base__flZo1"
};
export default ___CSS_LOADER_EXPORT___;
